/**
 * Utilidades para PermisosModel anidado (p. ej. padre "Reportes" con hijos en `hijos`).
 */

export const normalizePermTitle = (value) =>
  String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();

export const getPermNodeTitle = (row) => row?.moduloTitulo ?? row?.Nombre ?? row?.nombre ?? '';

const getPermChildNodes = (row) => {
  if (!row || typeof row !== 'object') return [];
  if (Array.isArray(row.hijos)) return row.hijos;
  if (Array.isArray(row.Hijos)) return row.Hijos;
  return [];
};

export const nodeHasReadAccess = (row) => {
  if (!row || typeof row !== 'object') return false;
  const acciones = Array.isArray(row?.AccionElemento) ? row.AccionElemento : [];
  const hasReadByAccion = acciones.some((a) => {
    const key = String(
      a?.accionClave ?? a?.AccionClave ?? a?.Accion?.Clave ?? a?.Accion?.Nombre ?? ''
    )
      .trim()
      .toUpperCase();
    return key === 'READ' || key === 'LECTURA';
  });
  const permisos = Array.isArray(row?.Permiso) ? row.Permiso : [];
  const hasReadByPermiso = permisos.some((p) => {
    const permisoNombre = String(p?.nombre ?? p?.Nombre ?? '').trim().toUpperCase();
    return permisoNombre === 'ACCESO' || permisoNombre === 'LECTURA' || permisoNombre === 'READ';
  });
  return hasReadByAccion || hasReadByPermiso;
};

/**
 * Recorre el árbol y devuelve títulos normalizados de nodos con lectura/acceso.
 */
export const collectReadablePermTitles = (permisosModel) => {
  const rows = Array.isArray(permisosModel) ? permisosModel : [];
  const out = new Set();

  const walk = (node) => {
    if (!node || typeof node !== 'object') return;
    if (nodeHasReadAccess(node)) {
      const t = normalizePermTitle(getPermNodeTitle(node));
      if (t) out.add(t);
    }
    for (const child of getPermChildNodes(node)) {
      walk(child);
    }
  };

  for (const root of rows) walk(root);
  return out;
};

export const permisosModelHasAnyTitle = (permisosModel, moduloTitulos = []) => {
  const readable = collectReadablePermTitles(permisosModel);
  const targets = new Set((Array.isArray(moduloTitulos) ? moduloTitulos : []).map(normalizePermTitle));
  if (targets.size === 0) return true;
  for (const t of targets) {
    if (readable.has(t)) return true;
  }
  return false;
};
